/** @format */

import React, { useCallback, useEffect, useState } from 'react';
import PaperedTable from '../../../components/Table/PaperedTable';
import { makeStyles, Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core';
import I18n from '../../../components/Translate/I18n';
import adescomStyle from '../../../assets/jss/adescom/adescomStyle';
import TableHeaderContentCell from '../../../components/Table/TableHeaderContentCell';
import Order from '../../../interfaces/forms/Order';
import Filter from '../../../interfaces/forms/Filter';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import { platformUserConstants } from '../../../modules/platformuser/actions';
import { PlatformUserCollectionInterface } from '../../../interfaces/platform/PlatformUserCollectionInterface';
import { FilterListReducerFieldName } from '../../../modules/filter/FilterListReducers';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import CardHeader from '../../../components/Heading/CardHeaderExt';
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import CardBody from '../../../components/Card/CardBody';
import Card from '../../../components/Card/Card';
import { roles, UserRoleHelper } from '../../../helpers/UserRoleHelper';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import DiscountForm from '../../Discount/Components/DiscountForm';
import GeneralDialog from '../../../components/Dialog/GeneralDialog';
import withStyles from '@material-ui/core/styles/withStyles';
import oplAppStyle from '../../../assets/themes/OPL/jss/App/OplAppStyle';
import SelectFromRest from '../../../components/Form/SelectFromRest';
import InputFormRest from '../../../components/Form/InputFormRest';
import CustomInputExtNumber from '../../../components/CustomInput/CustomInputExtNumber';
import { NotificationHelper } from '../../../helpers/NotificationHelper';
import EditButton from '../../../components/Buttons/EditButton';

interface WelcomeSmsPriceListPropsInterface {
    classes: any;
    platformResellerId: string | null;
}

interface SmsPricelistInterface {
    id?: number | null;
    zoneId: number | null;
    zone?: any;
    platformResellerId: number | null;
    outgoingPrice?: string | null;
    incomingPrice?: string | null;
    dataTransferPrice?: string | null;
    mmsPrice?: string | null;
    smsPrice?: string | null;
}

interface SmsPricelistStatusInterface {
    zoneId?: string;
    platformResellerId?: string;
    outgoingPrice?: string;
    incomingPrice?: string;
    dataTransferPrice?: string;
    mmsPrice?: string;
    smsPrice?: string;
}

const initEntity: SmsPricelistInterface = {
    platformResellerId: null,
    zoneId: null,
    outgoingPrice: null,
    incomingPrice: null,
    dataTransferPrice: null,
    mmsPrice: null,
    smsPrice: null,
};

const WelcomeSmsPriceList = (props: WelcomeSmsPriceListPropsInterface): React.ReactElement => {
    const dispatch = useDispatch();
    const { classes, platformResellerId } = props;

    const realPlatformResellerId = platformResellerId ? parseInt(platformResellerId.split('/')[platformResellerId.split('/').length - 1]) : null;

    const tableStickyHeader = { root: classes.tableStickyHeader };
    const tableCellRoot = { root: classes.tableCellRootBordered };
    const tableStickyCommand = { root: classes.tableStickyCommand };

    const [filters, setFilters] = useState<Array<Filter>>([]);
    const [orders, setOrders] = useState<Array<Order>>([]);

    const [welcomeSmsPriceListItems, setWelcomeSmsPriceListItems] = useState<any>(null);
    const [welcomeSmsAddModalOpen, setWelcomeSmsAddModalOpen] = useState<boolean>(false);

    const [zones, setZones] = useState<any>(null);

    const [entity, setEntity] = useState<SmsPricelistInterface>({
        ...initEntity,
        platformResellerId: realPlatformResellerId,
        zoneId: null,
    });

    const [editId, setEditId] = useState<number | null | undefined>(null);

    const updateOrderList = (orders: Array<Order>): void => setOrders(orders);
    const updateFilterList = (filters: Array<Filter>): void => setFilters(filters);

    const firstLoad = useCallback((): void => {
        const loaderCall = new ItemLoaders(dispatch);
        loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_reseller_zone_prices')),
            platformUserConstants.LIST,
            [...filters, { name: 'platformResellerId', value: realPlatformResellerId ?? -1 }],
            orders,
            (items: any): void => {
                setWelcomeSmsPriceListItems(items);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch, filters, orders, realPlatformResellerId]);

    const loadZones = useCallback((): void => {
        const loaderCall = new ItemLoaders(dispatch);
        loaderCall.getListWithCallback(
            FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/zones')),
            platformUserConstants.LIST,
            [{ name: 'customZoneType', value: 1 }],
            [],
            (items: any): void => {
                setZones(items);
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    }, [dispatch]);

    const clearFilters = (): void => {
        setFilters([]);
        setOrders([]);
    };

    const openWelcomeSmsPriceListAddModal = (): void => {
        setEntity({
            ...entity,
            zoneId: null,
            outgoingPrice: '',
            incomingPrice: '',
            smsPrice: '',
            mmsPrice: '',
            dataTransferPrice: '',
        });
        setWelcomeSmsAddModalOpen(true);
    };

    const closeWelcomeSmsPriceListAddModal = (): void => {
        setWelcomeSmsAddModalOpen(false);
        setEditId(null);
    };

    const changeSelectedZone = (e: any): void => {
        setEntity({ ...entity, [e.target.name]: e.target.value });
    };

    const changeInput = (e: any): void => {
        // TODO: Add validation (use entityStatus)
        setEntity({ ...entity, [e.target.name]: e.target.value });
    };

    const editPrice = (entity: SmsPricelistInterface): void => {
        openWelcomeSmsPriceListAddModal();
        setEntity({
            zoneId: entity.zoneId,
            platformResellerId: entity.platformResellerId,
            outgoingPrice: entity.outgoingPrice,
            incomingPrice: entity.incomingPrice,
            dataTransferPrice: entity.dataTransferPrice,
            mmsPrice: entity.mmsPrice,
            smsPrice: entity.smsPrice,
        });
        setEditId(entity.id);
    };

    const saveWelcomeSmsPriceList = (): void => {
        let ent = { ...entity };
        if (!ent.zoneId) {
            NotificationHelper.notifyError('notifications:welcome_sms.select_zone_missing', dispatch);
            return;
        }

        const loaderCall = new ItemLoaders(dispatch);
        if (!editId) {
            loaderCall.postWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/platform_reseller_zone_prices')),
                platformUserConstants.LIST,
                ent,
                (): void => {
                    firstLoad();
                    setEditId(null);
                    closeWelcomeSmsPriceListAddModal();
                },
                {
                    dispatchAfterCallback: true,
                    dispatchErrorAfterCallback: true,
                }
            );
        } else {
            loaderCall.putWithCallback(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath(`/platform_reseller_zone_prices/${editId}`)),
                platformUserConstants.LIST,
                ent,
                (): void => {
                    firstLoad();
                    setEditId(null);
                    closeWelcomeSmsPriceListAddModal();
                },
                {
                    dispatchAfterCallback: true,
                    dispatchErrorAfterCallback: true,
                }
            );
        }
    };

    useEffect(() => {
        firstLoad();
        loadZones();
    }, [firstLoad, loadZones]);

    useEffect(() => {
        console.log(entity);
    }, [entity]);

    return (
        <Card>
            <CardHeader icon={<MoneyOffIcon />} trans={'notifications:h.welcome_sms_prices'} />
            <CardBody>
                <PaperedTable>
                    <TableHead>
                        <TableRow>
                            {UserRoleHelper.checkRole(roles.ROLE_PLATFORM_DISCOUNT_POST) && (
                                <CustomTextButtom
                                    size={'sm'}
                                    callback={openWelcomeSmsPriceListAddModal}
                                    callbackParam={{}}
                                    label="notifications:b.add_price"
                                />
                            )}
                        </TableRow>
                        <TableRow>
                            <div style={{ display: 'flex' }}>
                                <CustomTextButtom size={'sm'} callback={firstLoad} callbackParam={{}} label="general:common.search" />

                                {(filters.length > 0 || orders.length > 0) && (
                                    <CustomTextButtom size={'sm'} callback={clearFilters} callbackParam={{}} label="general:common.clear_filter" />
                                )}
                            </div>
                        </TableRow>
                        <TableRow>
                            <TableCell classes={tableStickyCommand} padding="none" align="left" style={{ width: 30 }}>
                                <TableHeaderContentCell textAlign="left" title="general:common.commands" showSort={false} onlyFilter={false} />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="notifications:welcome_sms.zone_name"
                                    fieldName="zone.mainname"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="notifications:welcome_sms.outgoing_price"
                                    fieldName="outgoingPrice"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="notifications:welcome_sms.incoming_price"
                                    fieldName="incomingPrice"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="notifications:welcome_sms.data_transfer_price"
                                    fieldName="dataTransferPrice"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="notifications:welcome_sms.mms_price"
                                    fieldName="mmsPrice"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                            <TableCell classes={tableStickyHeader} padding="none" align="left">
                                <TableHeaderContentCell
                                    textAlign="left"
                                    title="notifications:welcome_sms.sms_price"
                                    fieldName="smsPrice"
                                    showSort={true}
                                    onlyFilter={false}
                                    defaultDirection="desc"
                                    searchFieldType="string"
                                    filters={filters}
                                    sort={orders}
                                    updateOrderList={updateOrderList}
                                    updateFilterList={updateFilterList}
                                    searchActionCallback={firstLoad}
                                />
                            </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {zones &&
                            welcomeSmsPriceListItems &&
                            welcomeSmsPriceListItems['hydra:member'].map((el: any, index: number) => {
                                return (
                                    <TableRow key={index}>
                                        <TableCell classes={tableCellRoot} padding="none" align="left" style={{ width: 30 }}>
                                            <EditButton callback={editPrice} callbackParam={el} />
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {el.zone.mainname}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {el.outgoingPrice}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {el.incomingPrice}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {el.dataTransferPrice}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {el.mmsPrice}
                                        </TableCell>
                                        <TableCell classes={tableCellRoot} padding="none" align="left">
                                            {el.smsPrice}
                                        </TableCell>
                                    </TableRow>
                                );
                            })}
                    </TableBody>
                </PaperedTable>
                <GeneralDialog
                    dialogType={'action'}
                    agreeCallback={saveWelcomeSmsPriceList}
                    agreeCallbackTextLabel={'general:common.save'}
                    disagreeCallbackTextLabel={'general:common:cancel'}
                    disagreeCallback={closeWelcomeSmsPriceListAddModal}
                    open={welcomeSmsAddModalOpen}
                    maxWidth={'lg'}
                    title={'notifications:h.add_welcome_sms_price_modal'}
                >
                    <GridContainer>
                        <GridItem xs={12}>
                            <GridContainer spacing={1}>
                                <GridItem xs={3}>
                                    <SelectFromRest
                                        classes={props.classes}
                                        callback={changeSelectedZone}
                                        required={false}
                                        restElements={zones ?? { 'hydra:member': [] }}
                                        stateName="zoneId"
                                        stateObjectState={null}
                                        selectedValue={entity.zoneId}
                                        propKey="id"
                                        propValue="mainname"
                                        addEmpty={false}
                                        displayEmpty={true}
                                        emptyLabel="notifications:welcome_sms.empty"
                                        label="notifications:welcome_sms.select_zone"
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                        <GridItem xs={12}>
                            <GridContainer spacing={1}>
                                <GridItem xs={2}>
                                    <CustomInputExtNumber
                                        onChange={changeInput}
                                        name="outgoingPrice"
                                        labelText="notifications:welcome_sms.outgoing_price"
                                        required={false}
                                        value={entity.outgoingPrice}
                                        decimalLimit={10}
                                    />
                                </GridItem>
                                <GridItem xs={2}>
                                    <CustomInputExtNumber
                                        onChange={changeInput}
                                        name="incomingPrice"
                                        labelText="notifications:welcome_sms.incoming_price"
                                        required={false}
                                        value={entity.incomingPrice}
                                        decimalLimit={10}
                                    />
                                </GridItem>
                                <GridItem xs={2}>
                                    <CustomInputExtNumber
                                        onChange={changeInput}
                                        name="dataTransferPrice"
                                        labelText="notifications:welcome_sms.data_transfer_price"
                                        required={false}
                                        value={entity.dataTransferPrice}
                                        decimalLimit={10}
                                    />
                                </GridItem>
                                <GridItem xs={2}>
                                    <CustomInputExtNumber
                                        onChange={changeInput}
                                        name="mmsPrice"
                                        labelText="notifications:welcome_sms.mms_price"
                                        required={false}
                                        value={entity.mmsPrice}
                                        decimalLimit={10}
                                    />
                                </GridItem>
                                <GridItem xs={2}>
                                    <CustomInputExtNumber
                                        onChange={changeInput}
                                        name="smsPrice"
                                        labelText="notifications:welcome_sms.sms_price"
                                        required={false}
                                        value={entity.smsPrice}
                                        decimalLimit={10}
                                    />
                                </GridItem>
                            </GridContainer>
                        </GridItem>
                    </GridContainer>
                </GeneralDialog>
            </CardBody>
        </Card>
    );
};

export default withStyles(oplAppStyle)(WelcomeSmsPriceList);
